// extracted by mini-css-extract-plugin
export default {"container":"editorial_container__YzwYy","title":"editorial_title__9ABcl","approach":"editorial_approach__rJLtp"};